module.exports = __webpack_public_path__ + "static/img/company-performance.d41a032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/company-performance.jpg
// module id = aOZM
// module chunks = 0